
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Header from '/home/circleci/app/packages/layout-header-component/src/entries/LoggedOut';

const element = typeof document !== 'undefined' && document.querySelector('#Header');
if (element) {
    const props = window.initialData['Header'];
    ReactDOM.hydrate(
        <Header {...props}/>,
        element
    );
}
export default Header;
